import 'jquery.easing';
import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_de';
import Lockr from 'lockr';
import 'bootstrap-select';
import 'bootstrap-select/js/i18n/defaults-de_DE';
import 'jquery.scrollto';


// BASIC FUNCTIONS
$.fn.getInputType = function () {
  if (typeof this[0] != 'undefined' && typeof this[0].tagName != 'undefined') {
    return this[0].tagName.toString().toLowerCase() === 'input' ?
      $(this[0]).prop('type').toLowerCase() :
      this[0].tagName.toLowerCase();
  } else {
    return false;
  }
}; // getInputType


const _isUndefined = (obj) => {
  return obj === void 0;
};

const swalWithBootstrapButtons = window.Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary mr-1',
    cancelButton: 'btn btn-secondary',
  },
  buttonsStyling: false,
});

var _base_serializeArray = $.fn.serializeArray;
$.fn.serializeArray = function () {
  var a = _base_serializeArray.apply(this);
  $.each(this.find('input'), function (i, e) {
    if (e.type == 'checkbox') {
      if (!e.checked) {
        a.splice(i, 0, {name: e.name, value: 'false'});
      }
    }
  });
  return a;
};
$.fn.serializeObject = function () {
  var data = {};

  function buildInputObject(arr, val) {
    if (arr.length < 1) {
      return val;
    }
    var objkey = arr[0];
    if (objkey.slice(-1) == ']') {
      objkey = objkey.slice(0, -1);
    }
    var result = {};
    if (arr.length == 1) {
      result[objkey] = val;
    } else {
      arr.shift();
      var nestedVal = buildInputObject(arr, val);
      result[objkey] = nestedVal;
    }
    return result;
  }

  function gatherMultipleValues(that) {
    var final_array = [];
    $.each(that.serializeArray(), function (key, field) {
      // Copy normal fields to final array without changes
      if (field.name.indexOf('[]') < 0) {
        final_array.push(field);
        return true; // That's it, jump to next iteration
      }

      // Remove "[]" from the field name
      var field_name = field.name.split('[]')[0];

      // Add the field value in its array of values
      var has_value = false;
      $.each(final_array, function (final_key, final_field) {
        if (final_field.name === field_name) {
          has_value = true;
          final_array[final_key]['value'].push(field.value);
        }
      });
      // If it doesn't exist yet, create the field's array of values
      if (!has_value) {
        final_array.push({'name': field_name, 'value': [field.value]});
      }
    });
    return final_array;
  }

  // Manage fields allowing multiple values first (they contain "[]" in their name)
  var final_array = gatherMultipleValues(this);

  // Then, create the object
  $.each(final_array, function () {
    var val = this.value;
    var c = this.name.split('[');
    var a = buildInputObject(c, val);
    $.extend(true, data, a);
  });

  return data;
};


export function skichampionshipForm() {
  if($('#msform').hasClass('tennischampionship-form')){
    Lockr.prefix = 'san_tennischampionship__';
  } else {
    Lockr.prefix = 'san_skichampionship__';
  }

  let currentFieldset, nextFieldset, previousFieldset, storage; //fieldsets
  let left, opacity, scale; //fieldset properties which we will animate
  let animating; //flag to prevent quick multi-click glitches

  currentFieldset = $('.ms-fieldsets').find('fieldset').first();

  let controlForm = $('#participant-accordion-parent:first');
  let currentEntry = $('#participant-accordion-parent .participant-accordion-item:first');

  let hotel_room_controlForm = $('#hotel-room-accordion-parent:first');
  let hotel_room_currentEntry = $('#hotel-room-accordion-parent .hotel-room-accordion-item:first');

  //first accordion
  let participant_counter = 2;
  let hotel_counter = 2;

  // INIT PLUGINS

  function scrollToForm() {
    $.scrollTo($('#formular'), 800, {offset: {top: -$('header').height()}});
  }

  $('.has-selectpicker').selectpicker('refresh');

  let ajaxAction = 'skichampionship_save_submission';

  if($('#msform').hasClass('tennischampionship-form')){
    ajaxAction = 'tennischampionship_save_submission';
  }

  console.log('ajaxAction', ajaxAction);

  let formValidation = $('#msform').validate({
    errorClass: 'warning',
    onfocusout: false,
    rules: {
      email: {
        required: true,
        email: true,
      },
    },
    invalidHandler: function(form, validator) {
      if (!validator.numberOfInvalids())
        return;

      $.scrollTo($(validator.errorList[0].element), 800, {offset: {top: -$('header').height()}});
    },
    errorPlacement: function (error, element) {
      if (element.attr('type') == 'radio' || element.attr('type') == 'checkbox') {
        error.appendTo(element.parents('.form-group').find('.warning-container'));
      } else {
        error.insertAfter(element);
      }
    },
    submitHandler: function () {
      $('button[type="submit"]').addClass('disabled').find('i').removeClass('d-none');

      $.ajax({
        type: 'POST',
        url: sanacorp.ajax_url,
        data: {
          'action': ajaxAction,
          'data': loadStorageData(),
        },
        success: function () {
          currentFieldset = $('fieldset.step-5');
          nextFieldset = $('fieldset.done');

          scrollToForm();

          animating = true;

          //show the next fieldset
          nextFieldset.show();
          //hide the current fieldset with style
          currentFieldset.animate({
            opacity: 0,
          }, {
            step: function (now) {
              //as the opacity of currentFieldset reduces to 0 - stored in "now"
              //1. scale currentFieldset down to 80%
              scale = 1 - (1 - now) * 0.2;
              //2. bring nextFieldset from the right(50%)
              left = (now * 50) + '%';
              //3. increase opacity of nextFieldset to 1 as it moves in
              opacity = 1 - now;
              currentFieldset.css({
                'transform': 'scale(' + scale + ')',
                'position': 'relative',
              });
              nextFieldset.css({
                'top': 0,
                'left': left,
                'opacity': opacity,
              });
            },
            duration: 800,
            complete: function () {
              currentFieldset.hide();
              animating = false;
            },
            //this comes from the custom easing plugin
            easing: 'easeInOutBack',
          });

          Lockr.rm('user');
          Lockr.rm('participant');
          Lockr.rm('hotel');
          Lockr.rm('tos');
        },
        error: function (request, status, error) {
          console.log(request);
          console.log(status);
          console.log(error);
          alert('Es ist ein Fehler aufgetreten! Bitte versuchen Sie es erneut');
        },
      });
    },
  });


  // ACCORDIONS

  function initParticipantAccordion() {
    $('.participant-accordion-item').each(function () {

      var accordionitem = $(this);

      //if item is checked it shows the conditional item
      accordionitem.find('input[type="checkbox"]').off('click').click(function () {
        var checkbox = $(this);
        if (accordionitem.find(checkbox).data('condition') && accordionitem.find('.' + accordionitem.find(checkbox).data('condition')).hasClass('d-none')) {
          accordionitem.find('.' + accordionitem.find(checkbox).data('condition')).removeClass('d-none');
        } else {
          accordionitem.find('.' + accordionitem.find(checkbox).data('condition')).addClass('d-none');
        }
      });

      accordionitem.find('.participant-delete').off('click').click(function (e) {
        e.preventDefault();
        swalWithBootstrapButtons.fire({
          title: 'Teilnehmer löschen',
          text: 'Möchten Sie diesen Teilnehmer wirklich löschen?',
          icon: false,
          showCancelButton: true,
          confirmButtonText: 'Ja',
          cancelButtonText: 'Abbrechen',
        }).then((result) => {
          if (result.isConfirmed) {
            participant_counter--;
            accordionitem.remove();
          }
        });
      });
    });
  }

  function resetParticipantAccordion($newEntry, index) {
    $newEntry.find('.warning').removeClass('warning');
    $newEntry.find('.valid').removeClass('valid');
    $newEntry.find('.participant-accordion-wrap').attr('id', 'participant-accordion_' + index);

    // replace participant ids
    $newEntry.find('label[for]').each(function () {
      $(this).attr('for', $(this).attr('for').replace('participant_1', 'participant_' + index));
    });

    $newEntry.find('input[data-condition]').each(function () {
      const oldCondition = $(this).attr('data-condition');
      const newCondition = $(this).attr('data-condition').replace('participant_1', 'participant_' + index);

      $(this).attr('data-condition', newCondition);
      $newEntry.find('.conditional-box.'+oldCondition).removeClass(oldCondition).addClass(newCondition);
    });

    $newEntry.find('input[id], textarea[id], select[id]').each(function () {
      $(this).attr('id', $(this).attr('id').replace('participant_1', 'participant_' + index));
    });

    // replace participant names
    $newEntry.find('input[name], textarea[name], select[name]').each(function () {
      $(this).attr('name', $(this).attr('name').replace('participant[1]', 'participant[' + index + ']'));
    });

    $newEntry.find('input[type="checkbox"]').each(function () {
      if ($(this).attr('data-condition') && !$newEntry.find('.' + $(this).attr('data-condition')).hasClass('d-none')) {
        $newEntry.find('.' + $(this).attr('data-condition')).addClass('d-none');
      }
    });

    $newEntry.find('[style]').removeAttr('style');
    $newEntry.find('.conditional-box').addClass('d-none');
    $newEntry.find('.participant').text(index + '. Teilnehmer');
    $newEntry.find('input').text('');
    $newEntry.find('input[type="text"]').val('');
    $newEntry.find('input[type="checkbox"]').prop('checked', false);
    $newEntry.find('input[type="radio"]').prop('checked', false);
    $newEntry.find('select > option').removeAttr('selected');
    $newEntry.find('select > option.form-default').attr('selected', 'selected');
    $newEntry.find('input[type="checkbox"].form-default').prop('checked', true);
    $newEntry.find('input[type="radio"].form-default').prop('checked', true);

    return $newEntry;
  }

  function resetHotelRoomAccordion($newEntry, index) {
    // replace participant ids
    $newEntry.find('label[for]').each(function () {
      $(this).attr('for', $(this).attr('for').replace('hotel_1', 'participant_' + index));
    });

    $newEntry.find('input[id], textarea[id], select[id]').each(function () {
      $(this).attr('id', $(this).attr('id').replace('hotel_1', 'participant_' + index));
    });

    // replace participant names
    $newEntry.find('input[name], textarea[name], select[name]').each(function () {
      $(this).attr('name', $(this).attr('name').replace('hotel[1]', 'hotel[' + index + ']'));
    });

    $newEntry.find('input[type="checkbox"]').each(function () {
      if ($(this).data('condition') && !$newEntry.find('.' + $(this).data('condition')).hasClass('d-none')) {
        $newEntry.find('.' + $(this).data('condition')).addClass('d-none');
      }
    });

    $newEntry.find('.warning').removeClass('warning');
    $newEntry.find('.valid').removeClass('valid');
    $newEntry.find('.hotel-room-accordion-wrap').attr('id', 'hotel-room-accordion_' + index);


    $newEntry.find('select[id]').each(function () {
      if ($(this).attr('id')) {
        $newEntry.find('#' + $(this).attr('id')).attr('id', 'hotel-room-accordion_' + index + '_' + $(this).attr('id'))
      }
    });

    $newEntry.find('[style]').removeAttr('style');
    $newEntry.find('.hotel-room').text(index + '. Hotelzimmer');
    $newEntry.find('input').text('');
    $newEntry.find('input').val('');
    $newEntry.find('textarea').val('');
    $newEntry.find('input[type="checkbox"]').prop('checked', false);
    $newEntry.find('input[type="radio"]').prop('checked', false);
    $newEntry.find('select > option').removeAttr('selected');
    $newEntry.find('select > option.form-default').attr('selected', 'selected');
    $newEntry.find('input[type="checkbox"].form-default').prop('checked', true);
    $newEntry.find('input[type="radio"].form-default').prop('checked', true);

    $newEntry.find('input[name]').each(function () {
      if ($(this).attr('name')) {
        $newEntry.find($(this)).attr('name', index + '_' + $(this).attr('name'))
      }
    });

    return $newEntry;
  }

  function initHotelRoomAccordion() {
    $('.hotel-room-accordion-item').each(function () {

      var accordionitem = $(this);

      accordionitem.find('.hotel-room-delete').off('click').click(function (e) {
        e.preventDefault();
        swalWithBootstrapButtons.fire({
          title: 'Hotelzimmer löschen',
          text: 'Möchten Sie dieses Hotelzimmer wirklich löschen?',
          icon: false,
          showCancelButton: true,
          confirmButtonText: 'Ja',
          cancelButtonText: 'Abbrechen',
        }).then((result) => {
          if (result.isConfirmed) {
            hotel_counter--;
            accordionitem.remove();
          }
        });
      });
    });
  }

  initParticipantAccordion();
  initHotelRoomAccordion();

  $('.participant-add').click(function (e) {
    e.preventDefault();

    if (formValidation.form()) {
      // clone
      var $newEntry = currentEntry.clone();

      // reset
      $newEntry = resetParticipantAccordion($newEntry, participant_counter);

      $newEntry.find('.btn-delete.disabled').removeClass('disabled');
      $newEntry.appendTo(controlForm);

      participant_counter++;

      initParticipantAccordion();

      $.scrollTo($newEntry, 800, {offset: {top: -$('header').height()}});
    } else {
      $.scrollTo($('#participant-accordion-parent').find('.participant-accordion-item').last(), 800, {offset: {top: -$('header').height()}})
    }
  });

  $('.hotel-room-add').click(function (e) {
    e.preventDefault();

    if (formValidation.form()) {

      $('.has-selectpicker').selectpicker('destroy');
      //validate
      var $newEntry = hotel_room_currentEntry.clone();

      $newEntry = resetHotelRoomAccordion($newEntry, hotel_counter);

      $newEntry.find('.btn-delete.disabled').removeClass('disabled');
      $newEntry.appendTo(hotel_room_controlForm);

      $('.has-selectpicker').selectpicker();
      hotel_counter++;

      initHotelRoomAccordion();

      $.scrollTo($newEntry, 800, {offset: {top: -$('header').height()}});
    } else {
      $.scrollTo($('#hotel-room-accordion-parent').find('.hotel-room-accordion-item').last(), 800, {offset: {top: -$('header').height()}})
    }
  });

  // MULTISTEP FUNCTIONS

  $('.next').click(function () {
    currentFieldset = $(this).parents('fieldset');
    nextFieldset = $(this).parents('fieldset').next();

    if (animating) {
      return false;
    }

    if (formValidation.form()) {
      scrollToForm();
      currentFieldset.find('.error-occured').hide();

      animating = true;

      storage = currentFieldset.data('storage');

      let fieldSetData = $(currentFieldset).serializeObject();

      if (storage == 'participant') {
        fieldSetData = fieldSetData.participant;
      } else if (storage == 'hotel') {
        fieldSetData = fieldSetData.hotel;
      }

      Lockr.set(storage, fieldSetData);

      if (nextFieldset.hasClass('step-3') || nextFieldset.hasClass('step-5')) {
        let participants = [];

        nextFieldset.find('select.hotel-guest-select option[value]').not(':first').each(function () {
          $(this).remove();
        });

        $.each(Lockr.get('participant'), function (index, participant) {
          let name = participant.data.firstname + ' ' + participant.data.lastname;
          participants.push(name);
        });

        nextFieldset.find('select.hotel-guest-select').find('option').remove();
        $.each(participants, function (i, participant) {
          $('select.hotel-guest-select').append($('<option>', {
            value: participant,
            text: participant,
          }));
        });

        $('.has-selectpicker').selectpicker('refresh');
      }

      lockrFillData(nextFieldset);

      $('.has-selectpicker').selectpicker('refresh');

      //activate next step on progressbar using the index of nextFieldset
      $('#progressbar li').eq($('fieldset').index(nextFieldset)).addClass('active');

      //show the next fieldset
      nextFieldset.show();

      //hide the current fieldset with style
      currentFieldset.animate({
        opacity: 0,
      }, {
        step: function (now) {
          //as the opacity of currentFieldset reduces to 0 - stored in "now"
          //1. scale currentFieldset down to 80%
          scale = 1 - (1 - now) * 0.2;
          //2. bring nextFieldset from the right(50%)
          left = (now * 50) + '%';
          //3. increase opacity of nextFieldset to 1 as it moves in
          opacity = 1 - now;
          currentFieldset.css({
            'transform': 'scale(' + scale + ')',
            'position': 'relative',
          });
          nextFieldset.css({
            'top': 0,
            'left': left,
            'opacity': opacity,
          });
        },
        duration: 800,
        complete: function () {
          currentFieldset.hide();
          animating = false;
        },
        //this comes from the custom easing plugin
        easing: 'easeInOutBack',
      });
    } else {
      currentFieldset.find('.error-occured').fadeIn();
    }
  });

  $('.previous').click(function () {
    scrollToForm();

    if (animating) return false;
    animating = true;

    currentFieldset = $(this).parents('fieldset');
    previousFieldset = $(this).parents('fieldset').prev();

    storage = currentFieldset.data('storage');

    if (currentFieldset.hasClass('step-2')) {
      $('#participant-accordion-parent').find('.participant-accordion-item').not(':first').remove();
      resetParticipantAccordion($('#participant-accordion-parent').find('.participant-accordion-item').first(), 1);
      participant_counter = 2;
    } else if (currentFieldset.hasClass('step-3')) {
      $('#hotel-room-accordion-parent').find('.hotel-room-accordion-item').not(':first').remove();
      resetHotelRoomAccordion($('#hotel-room-accordion-parent').find('.hotel-room-accordion-item').first(), 1);
      hotel_counter = 2;
    } else if (currentFieldset.hasClass('step-5')) {
      currentFieldset.find('.participant-accordion').find('.participant-accordion-item').not(':first').remove()
      resetParticipantAccordion(currentFieldset.find('.participant-accordion').find('.participant-accordion-item').first(), 1);
      participant_counter = 2;

      currentFieldset.find('.hotel-room-accordion').find('.hotel-room-accordion-item').not(':first').remove();
      resetHotelRoomAccordion(currentFieldset.find('.hotel-room-accordion').find('.hotel-room-accordion-item').first(), 1);
      hotel_counter = 2;
    }


    // if (typeof storage != 'undefined') {
    //   Lockr.rm(storage);
    // }

    $('#progressbar li').eq($('fieldset').index(currentFieldset)).removeClass('active');

    previousFieldset.show();

    currentFieldset.animate({
      opacity: 0,
    }, {
      step: function (now) {
        //as the opacity of currentFieldset reduces to 0 - stored in "now"
        //1. scale previousFieldset from 80% to 100%
        scale = 0.8 + (1 - now) * 0.2;
        //2. take currentFieldset to the right(50%) - from 0%
        left = ((1 - now) * 50) + '%';
        //3. increase opacity of previousFieldset to 1 as it moves in
        opacity = 1 - now;
        currentFieldset.css({
          'left': left,
        });
        previousFieldset.css({
          'transform': 'scale(' + scale + ')',
          'opacity': opacity,
        });
      },
      duration: 800,
      complete: function () {
        currentFieldset.hide();
        animating = false;
      },
      easing: 'easeInOutBack',
    });
  });

  // LOCAL STORAGE

  function loadStorageData() {
    let data = {
      user: Lockr.get('user'),
      participant: Lockr.get('participant'),
      hotel: Lockr.get('hotel'),
      tos: Lockr.get('tos'),
    };

    return data;
  }

// eslint-disable-next-line
  function fillCheckUserData(data, target) {
    $.each(data, function (key, value) {

      let data = '-';
      if (!_isUndefined(value)) {
        data = value;
      }

      $('#check-data').find('.' + target + '[data-index="' + key + '"]').html(data);
    });
  }

  // Handle Local Storage

  function lockrFillUserData($fieldset, data, identifier, currentStorage) {
    $.each(data, function (key, value) {
      if (currentStorage == 'all' && (_isUndefined(value) || value == '')) {
        value = '-';
      }

      $fieldset.find('.' + identifier + '[name="' + key + '"]').val(value);
    });
  }


  function fillAccordionParticipantForm($form, data, identifier, currentStorage) {
    $.each(data.data, function (key, value) {
      let $input = $form.find('.' + identifier + '[data-fill="' + key + '"]');

      switch ($input.getInputType()) {
        case 'text':
          if (currentStorage == 'all' && (_isUndefined(value) || value == '')) {
            value = '-';
          }

          $input.val(value);
          break;
      }
    });

    $.each(data.dynamic, function (key, value) {
      let $input = $form.find('.' + identifier + '[data-fill="' + key + '"]');
      let checked = false;
      let lastInput = false;
      let hasValue = false;
      let $lastConditionalInput = false;

      switch ($input.getInputType()) {
        case 'checkbox':
          if (value.value != 'false') {
            $input.prop('checked', true);

            if (typeof $input.data('condition') !== 'undefined') {
              $('.' + $input.data('condition')).removeClass('d-none');
            }
          } else if (currentStorage == 'all') {
            $input.parents('.form-wrap').hide();
          }

          // Conditional Checkbox
          $lastConditionalInput = $input;
          hasValue = false;
          if (typeof value.items == 'object') {
            $.each(value.items, function (i, v) {
              let $input = $form.find('.' + identifier + '[data-fill="' + i + '"]');

              switch ($input.getInputType()) {
                case 'text':
                  if (currentStorage == 'all' && (_isUndefined(v.value) || v.value == '')) {
                    v.value = '-';
                  } else {
                    hasValue = true;
                  }

                  $input.val(v.value);
                  break;
                case 'select':
                  hasValue = true;
                  $input.find('option[value="' + v.value + '"]').attr('selected', 'selected');
                  break;
                case 'checkbox':
                  if (v.value != 'false') {
                    hasValue = true;
                    $input.prop('checked', true);
                  }
                  break;
              }
            });
          }

          if(currentStorage == 'all' && !hasValue){
            if ($lastConditionalInput.data('condition')) {
              $form.find('.'+$lastConditionalInput.data('condition')).addClass('d-none');
            } else {
              $form.find('.'+$lastConditionalInput.data('condition')).removeClass('d-none');
            }
          }
          break;

        case 'select':
          if (currentStorage == 'all' && (_isUndefined(value.value) || value.value == '')) {
            $input.parents('.form-wrap').hide();
          } else {
            $input.find('option[value="' + value.value + '"]').attr('selected', 'selected');
          }
          break;

        case 'text':
          if (currentStorage == 'all' && (_isUndefined(value) || value == '')) {
            $input.parents('.form-wrap').hide();
          } else {
            $input.val(value.value);
          }
          break;

        default:
          // Multicheckbox
          checked = false;
          lastInput = false;
          if (typeof value.items == 'object') {
            $.each(value.items, function (i, v) {
              let $input = $form.find('.' + identifier + '[data-fill="' + key + '-' + i + '"]');

              if (v != 'false') {
                checked = true;
                $input.prop('checked', false);
                $input.prop('checked', true);
              } else {
                if (currentStorage == 'all') {
                  $input.parents('.form-check').hide();
                }
              }

              lastInput = $input
            });

            if (currentStorage == 'all' && checked == false) {
              lastInput.parents('.form-wrap').hide();
            }
          }

          break;
      }
    });
  }

  function lockrFillParticipantData($fieldset, data, identifier, currentStorage) {
    $.each(data, function (key, value) {
      if (key >= 2) {
        //validate
        var $newEntry = $fieldset.find('.participant-accordion').find('.participant-accordion-item').first().clone();
        $newEntry = resetParticipantAccordion($newEntry, key);

        fillAccordionParticipantForm($newEntry, value, identifier, currentStorage);

        $newEntry.find('.btn-delete.disabled').removeClass('disabled');
        $newEntry.appendTo($fieldset.find('.participant-accordion'));
      } else {
          fillAccordionParticipantForm($fieldset.find('.participant-accordion').find('.participant-accordion-item').first(), value, identifier, currentStorage);
      }

      participant_counter = parseInt(key) + 1;
    });

    initParticipantAccordion();
  }

  function fillAccordionHotelForm($form, data, identifier, currentStorage) {
    $.each(data, function (key, value) {
      let $input = $form.find('.' + identifier + '[data-fill="' + key + '"]');

      if ($input.hasClass('has-selectpicker')) {
        $input.find('option').removeAttr('selected');

        $.each(value, function (index, guest) {
          $input.find('option[value="' + guest + '"]').attr('selected', 'selected');
        });
      } else {
        switch ($input.getInputType()) {
          case 'text':
          case 'textarea':
            if (currentStorage == 'all' && (_isUndefined(value) || value == '')) {
              value = '-';
            }

            $input.val(value);

            break;
          case 'select':
            $input.find('option').prop('selected', false);
            $input.find('option[value="' + value + '"]').prop('selected', true);
            break;
        }
      }
      if (currentStorage == 'all' && _isUndefined(data.guest)) {
        $form.find('.select-picker').addClass('is-empty').html('-');
      }
    });
  }

  function lockrFillHotelData($fieldset, data, identifier, currentStorage) {

    $.each(data, function (key, value) {
      if (key >= 2) {
        //validate
        $('.has-selectpicker').selectpicker('destroy');

        let $newEntry = $fieldset.find('.hotel-room-accordion').find('.hotel-room-accordion-item').first().clone();
        $newEntry = resetHotelRoomAccordion($newEntry, key);

        fillAccordionHotelForm($newEntry, value, identifier, currentStorage);

        $newEntry.find('.btn-delete.disabled').removeClass('disabled');
        $newEntry.appendTo($fieldset.find('.hotel-room-accordion'));
      } else {
        fillAccordionHotelForm($fieldset.find('.hotel-room-accordion').find('.hotel-room-accordion-item').first(), value, identifier);
      }
      hotel_counter = parseInt(key) + 1;
      $('.has-selectpicker').selectpicker();
    });

    initHotelRoomAccordion();

    if (currentStorage == 'all') {
      var to = setTimeout(function () {
        clearTimeout(to);
        $fieldset.find('textarea').each(function (index, element) {
          element.style.height = element.scrollHeight + 'px';
        });
      }, 300)
    }
  }

  function lockrFillTosData($fieldset, data, identifier) {
    $.each(data, function (key, value) {
      let $input = $fieldset.find('.' + identifier + '[data-fill="' + key + '"]');

      switch ($input.getInputType()) {
        case 'checkbox':
          if (value != 'false') {
            $input.prop('checked', false);
            $input.prop('checked', true);
          }
          break;

        case 'radio':
          $.each($input, function (index, element) {
            if (value == $(element).val()) {
              $(element).prop('checked', true);
            } else {
              $(element).prop('checked', false);
            }
          });
          break;
      }
    });
  }

  function lockrFillData($fieldset) {
    let currentStorage = $fieldset.data('storage');
    let localStorageData = loadStorageData();

    if (currentStorage == 'user' || currentStorage == 'all') {
      lockrFillUserData($fieldset, localStorageData.user, 'fill-user', currentStorage);
    }

    if (currentStorage == 'participant' || currentStorage == 'all') {
      lockrFillParticipantData($fieldset, localStorageData.participant, 'fill-participant', currentStorage);
    }

    if (currentStorage == 'hotel' || currentStorage == 'all') {
      lockrFillHotelData($fieldset, localStorageData.hotel, 'fill-hotel', currentStorage);
    }

    if (currentStorage == 'tos' || currentStorage == 'all') {
      lockrFillTosData($fieldset, localStorageData.tos, 'fill-tos');
    }

    if(currentStorage == 'all'){
      $fieldset.find('.tos-payment-method').addClass('d-none');

      if(localStorageData.tos.payment_method == 'Überweisung'){
        $fieldset.find('.payment-ueberweisung').removeClass('d-none');
      } else {
        $fieldset.find('.payment-lastschrift').removeClass('d-none');
      }
    }
  }

  lockrFillData(currentFieldset);
}



// WEBPACK FOOTER //
// ./scripts/components/skichampionship-form.js